module.exports = __webpack_public_path__ + "img/poster_header.d0e281f7.png";